import { writable } from 'svelte/store'

export const data = writable(false)
export const currentIndex = writable(false)
export const jenksBreaks = writable(false)
export const geo2data = writable(false)
export const ann = writable(false)
export const geojsonPath = writable(false)
export const showChange = writable(false)

export const changeBreaks = [-100, -10, -5, 0, 5, 10, 10000];